import React, { useEffect, useState } from "react";
import {
  Show,
  TabbedShowLayout,
  Tab,
  ReferenceField,
  BooleanField,
  DeleteButton,
  TextField,
  DateField,
  NumberField,
  ReferenceManyField,
  Datagrid,
  DatagridBody,
  TopToolbar,
  RefreshButton,
  ListButton,
  EditButton,
  Button,
  Link,
  List,
  ShowController,
  SimpleShowLayout,
  useShowController,
  ShowView,
  ShowContextProvider,
  useRecordContext,
  usePermissions,
  useTranslate,
  useResourceContext,
  useGetOne,
  useRedirect,
  useListContext,
  FormDataConsumer,
  FunctionField,
  Labeled,
} from "react-admin";
import {
  AmountField,
  LineItemTotalField,
  ExpectedDateField,
  CamelCaseField,
  ConvQtyField,
  ConvQtyUomField,
  PaymentAmountField,
} from "./common";
// import { LineItemsSideComponent } from '../singleDeliveryOrders/common';
import CreateSDOButton from "./createSdoButton";
import { getLocalStorageKey, getCurrencySymbol } from "../common/common";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
// import AccessAlarmIcon from '@mui/icons-material/AccessAlarmIcon';

import CustomModal from "./CustomModal";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import noImage from "../images/combined-shape.svg";

let DeliveryNumber = 0;
let RecordId = [];
const apiUrl = RUN_TIME_API_ENDPOINT;
let orderStatus = null;
let isSdoCreated = 0;

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const CreateUser = ({ data, basePath, resource }) => {
//   console.log("record", data, basePath, resource);
//   return (
//     <Button
//       className="custom-button"
//       component={Link}
//       to={{
//         pathname: `/users/create`,
//         business_id: data && data.business_id,
//       }}
//     >
//       <span>Create User</span>
//     </Button>
//   );
// };

const ShowActions = (props) => {
  // const digitalOrderStatusKeyMappings = getLocalStorageKey('order_status_key_mappings');
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     openModal: false,
  //     openMessageModal: false,
  //     isResendBtnDisable: false,
  //     openPaymentModal: false,
  //     openPaymentMessageModal: false,
  //   };
  // }
  const record = useRecordContext();
  const location = useLocation();
  const redirect = useRedirect();

  const [openModal, setOpenModal] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [isResendBtnDisable, setIsResendBtnDisable] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openPaymentMessageModal, setOpenPaymentMessageModal] = useState(false);
  const [openOrderSendModal, setOpenOrderSendModal] = useState(false);
  const [openOrderSendRocksModal, setOpenOrderSendRocksModal] = useState(false);
  const [openOrderSendMsgModal, setOpenOrderSendMsgModal] = useState(false);

  // open modal function
  const onOpenModal = () => {
    // this.setState({ openModal: true });
    setOpenModal(true);
  };

  const onSendOrderE1 = (data) => {
    console.log("umesh data", data.contarctDetails.contract_type);
    console.log("umesh data", data.mode_of_transport);
    if (
      ["C1", "C6", "CU"].includes(data?.contarctDetails?.contract_type) &&
      data.mode_of_transport === "Truck"
    ) {
      console.log("You are goood to go");
      setOpenOrderSendModal(true);
      // this.setState({ openOrderSendModal: true });
    } else {
      Swal.fire({
        text: "Sorry! This order does not belong to contract types C1, C6 or CU and hence can't be sent to E1. 😞",
        confirmButtonText: `OK`,
        icon: "error",
      }).then((result) => {
        console.log("reload inside SW successful");
      });
    }
  };

  const onSendOrderToRocks = () => {
    setOpenOrderSendRocksModal(true);
  };

  const onCloseSendOrderE1 = () => {
    setOpenOrderSendModal(false);
  };

  const onCloseSendOrderRocks = () => {
    setOpenOrderSendRocksModal(false)
  }

  const onChangeMappingClick = () => {
    setOpenOrderSendModal(false);
    let _paramsUrl = location.pathname.split("/");
    let orderId;
    if (_paramsUrl.length > 1 && _paramsUrl[2] !== "") {
      orderId = _paramsUrl[2];
    }
    redirect(`/sap_digital_app_orders/${orderId}`);
    // location.pathname =
    //   location.pathname + "/#/sap_digital_app_orders/" + orderId;
  };

  const onCloseModal = () => {
    // this.setState({ openModal: false });
    setOpenModal(false);
  };

  const onOkModal = (data) => {
    // this.setState({ openModal: false, openMessageModal: true });
    setOpenModal(false);
    setOpenMessageModal(true);

    // console.log(openMessageModal,data.order_number);
    const url = `${apiUrl}/sap_digital_orders/${data.id}/resend_order`;
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify({});

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json.data.resend_status);
        if (json.data.resend_status === "Re-sending") {
          // this.setState({ isResendBtnDisable: true });
          setIsResendBtnDisable(true);
          props.fromChildToParentCallback(true);
        }
      });
  };

  // open msg modal function
  const onCloseMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const onOkMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
    setOpenOrderSendMsgModal(false);
    // openOrderSendMsgModal
  };

  const onOkSendOrderE1Modal = (data) => {
    setOpenModal(false);
    setOpenOrderSendModal(false);
    setOpenOrderSendMsgModal(true);
    // this.setState({
    //   openModal: false,
    //   openOrderSendModal: false,
    //   openOrderSendMsgModal: true,
    // });
    // console.log(this.state.openMessageModal,data.order_number);
    const url = `${apiUrl}sap_digital_orders/create_order`;
    const options = CommonHeaderOption();
    options.method = "POST";
    let dataToSend = {
      order_number: [data.order_number]
    };
    options.body = JSON.stringify(dataToSend);;
    // options.body = JSON.stringify({ order_number: data.order_number });

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        // console.log("json ===>", json.data.resend_status);
        // if (json.data.resend_status === "Re-sending") {
        //   this.setState({
        //     isResendBtnDisable: true,
        //     openOrderSendMsgModal: true,
        //   });
        //   this.props.fromChildToParentCallback(true);
        // }
      });
  };

  const onOkSendOrderRocksModal = (data) => {
    setOpenModal(false);
    setOpenOrderSendRocksModal(false);
    setOpenOrderSendMsgModal(true);
    const url = `${apiUrl}sap_digital_orders/send_order_to_rocks`;
    const options = CommonHeaderOption();
    options.method = "POST";
    let dataToSend = {
      order_number: [data.order_number]
    };
    options.body = JSON.stringify(dataToSend);;

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
      //  
      });
  };



  /**
   *
   * @returns Payment resend button
   */
  // open modal function
  const onPaymentOpenModal = () => {
    // this.setState({ openPaymentModal: true });
    setOpenPaymentModal(true);
  };

  const onPaymentCloseModal = () => {
    // this.setState({ openPaymentModal: false });\
    setOpenPaymentModal(false);
  };

  const onPaymentOkModal = (data) => {
    console.log("onPaymentOkModal data", data);
    // this.setState({ openPaymentModal: false, openPaymentMessageModal: true });
    setOpenPaymentModal(false);
    setOpenPaymentMessageModal(true);

    // console.log(openMessageModal,data.order_number);
    const url = `${apiUrl}/payment_status_confirm?order_id=${data.id}`;
    const options = CommonHeaderOption();
    options.method = "GET";
    // options.body = JSON.stringify({});

    fetch(url, options)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log("json ===>", json.data);
        // if (json.data.resend_status === "Re-sending") {
        //   this.setState({ isResendBtnDisable: true });
        //   props.fromChildToParentCallback(true);
        // }
      });
  };

  // open msg modal function
  const onPaymentCloseMessageModal = () => {
    // this.setState({ openPaymentMessageModal: false });
    setOpenPaymentMessageModal(false);
  };

  const onPaymentOkMessageModal = () => {
    // this.setState({ openPaymentMessageModal: false });
    setOpenPaymentMessageModal(false);
  };

  const { basePath, resource } = props;
  const translate = useTranslate();

  console.log("record....outside", record);
  const { data } = useGetOne("sap_digital_app_orders", { id: record?.id });
  console.log("data E1", data);

  let orderModelText = `<h6>Are you sure you want to send this order with the following details to E1?</h6>
<p>Contract number : ${data?.contarctDetails?.contract_number}</p>
<p>Dispatch date : ${moment(data?.delivery_date_from).format("DD/MM/YYYY")}</p>
<p>Special instruction : ${
    data?.mode_of_delivery === "delivered"
      ? data?.customer_ref_number
      : data?.special_instructions || "-"
  }</p>`;

  // if (data?.mode_of_delivery === "delivered") {
  //   orderModelText += `<p>${translate(
  //     "resources.sap_digital_app_orders.fields.site_opening"
  //   )} : ${moment(data?.delivery_date_from).format("HH:mm")}</p>
  // <p>${translate(
  //   "resources.sap_digital_app_orders.fields.site_closing"
  // )} : ${moment(data?.delivery_to_date).format("HH:mm")}</p>`;
  // }

  if (data?.mode_of_delivery === "delivered") {
    orderModelText += `<p>${translate(
      "resources.sap_digital_app_orders.fields.delivery_window"
    )} : ${moment(data?.delivery_date_from).format("HH:mm")} - ${moment(data?.delivery_to_date).format("HH:mm")}</p>`;
  }
  orderModelText += "<br>";

  // data &&
  //   data.digital_order_line_items &&
  //   data.digital_order_line_items.forEach((item) => {
  //     // if (item.product_master.name != undefined) {
  //     console.log("item E1 ==>", item.product_master.name);
  //     orderModelText +=
  //       "<p> Product Name : " +
  //       item.product_master.product_name +
  //       "</p><p> Product Code :  " +
  //       item.product_master.material_code +
  //       "</p><p> Quantity : " +
  //       item.quantity +
  //       "</p><p> Supply Unit : " +
  //       (item.plant_name ? item.plant_name : "-") +
  //       " </p><BR>";
  //     // }
  //   });

  let orderModalTextRocks = `<h6>Are you sure you want to send this order with the following details to ROCKs?</h6>
  <p>Contract number : ${data?.contarctDetails?.contract_number}</p>
  <p>Dispatch date : ${moment(data?.delivery_date_from).format("DD/MM/YYYY")}</p>
  <p>Special instruction : ${
      data?.mode_of_delivery === "delivered"
      ? data?.customer_ref_number
      : data?.special_instructions || "-"
  }</p>`;

  const { permissions } = usePermissions();
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];

  orderStatus = data && data.customer_order_status;
  isSdoCreated =
    data && data.sap_sdo_for_orders && data.sap_sdo_for_orders.length;

  let currentDate = new Date().toISOString().replace(/T.*/, "");
  let fetchedDate = moment(data?.delivery_date_from)
    .toISOString()
    .replace(/T.*/, "");
  let fetchedDateCollect = moment(fetchedDate)
    .add(1, "days")
    .format("YYYY-MM-DD");

  return (
    <TopToolbar className="toolbar-center-align">
      {permissions !== "isManual" &&
        data &&
        data.digital_order_system === "isSapPH" &&
        data.customer_order_status != 0 && (
          <Button
            className="custom-button resend-button"
            onClick={onPaymentOpenModal}
            //   disabled={
            //     !!isResendBtnDisable ||
            //     data.resend_status === "Re-sending"
            //   }
          >
            <span className="button-spacing-left">Send payment info</span>
          </Button>
        )}
      {permissions !== "isManual" && data && !!openPaymentModal ? (
        <CustomModal
          open={openPaymentModal}
          onCloseModal={onPaymentCloseModal}
          showCancel={true}
          text="Are you sure you want to send the payment information to SAP?"
          onOkModal={(data) => onPaymentOkModal(data)}
          data={data}
          isSuccess={true}
        />
      ) : null}
      {openOrderSendModal ? (
        <CustomModal
          open={openOrderSendModal}
          onCloseModal={onCloseSendOrderE1}
          showCancel={false}
          showChangeProduct
          renderHtmlText
          text={orderModelText}
          onNewButtonClick={onChangeMappingClick}
          okBtnText={"Confirm Send to E1"}
          onOkModal={() => onOkSendOrderE1Modal(data)}
          data={data}
          isSuccess={false}
        />
      ) : null}
      {openOrderSendRocksModal ? (
        <CustomModal
          open={openOrderSendRocksModal}
          onCloseModal={onCloseSendOrderRocks}
          showCancel={false}
          renderHtmlText
          text={orderModalTextRocks}
          okBtnText={"Confirm Send to Rocks"}
          onOkModal={() => onOkSendOrderRocksModal(data)}
          data={data}
          isSuccess={false}
        />
      ) : null}
      {permissions !== "isManual" && data && !!openPaymentMessageModal ? (
        <CustomModal
          open={openPaymentMessageModal}
          onCloseModal={onPaymentCloseMessageModal}
          showCancel={false}
          text="Data is successfully accepted"
          onOkModal={onPaymentOkMessageModal}
          data={data}
          isSuccess={true}
        />
      ) : null}

      {openOrderSendMsgModal ? (
        <CustomModal
          open={openOrderSendMsgModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Your order is being sent to the system. You can check it's progress in the detail page."
          onOkModal={onOkMessageModal}
          data={data}
          isSuccess={true}
        />
      ) : null}

      {permissions !== "isManual" &&
        data &&
        (data.digital_order_system === "isSap" ||
          data.digital_order_system === "isSageAPI" ||
          data.digital_order_system === "isJDE" ||
          data.digital_order_system === "isSapPH" ||
          data.digital_order_system === "isMulesoft") &&
        (data.customer_order_status === 0 ||
          data.resend_status === "Re-send failed - Try again") && (
          <Button
            className="custom-button resend-button"
            onClick={onOpenModal}
            disabled={
              !!isResendBtnDisable || data.resend_status === "Re-sending"
            }
          >
            <span className="button-spacing-left">Re-send order</span>
          </Button>
        )}
      {permissions !== "isManual" && data && !!openModal ? (
        <CustomModal
          open={openModal}
          onCloseModal={onCloseModal}
          showCancel={true}
          text="Are you sure you want to re-send this order ?"
          onOkModal={(data) => onOkModal(data)}
          isSuccess={true}
        />
      ) : null}
      {permissions !== "isManual" && data && !!openMessageModal ? (
        <CustomModal
          open={openMessageModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Your order is being re-sent to the system. You can check it's progress in the detail page."
          onOkModal={onOkMessageModal}
          isSuccess={true}
        />
      ) : null}
      {/* <CreateUser data={data} basePath={basePath} resource={resource} /> */}
      <RefreshButton />
      <ListButton basePath={basePath} />
      {/* {permissions === "isManual" && ( */}
      {(data?.customer_order_status === "0" || permissions === "isManual") && !data?.is_rocks_order && (
        <EditButton resource={basePath} record={data} />
      )}
      {data &&
        data?.customer_order_status === "0" &&
        data.lr_order_number === data.order_number &&
        countryCode == "GB" &&
        !data?.is_rocks_order && (
          <Button
            className="custom-button resend-button"
            onClick={() => onSendOrderE1(data)}
            // disabled={
            //   !!this.state.isResendBtnDisable ||
            //   data.resend_status === "Re-sending"
            // }
            disabled={
              data?.mode_of_delivery === "delivered"
                ? moment(fetchedDate).isBefore(currentDate)
                : moment(fetchedDateCollect).isBefore(currentDate)
            }
          >
            <span className="button-spacing-left">Send Order To E1</span>
          </Button>
      )}

      {data &&
        data?.is_rocks_order &&
        data.lr_order_number === data.order_number &&
        countryCode == "GB" &&
        data?.customer_order_status === "0" && (
          <Button
            className="custom-button resend-button"
            onClick={onSendOrderToRocks}
            disabled={
              data?.mode_of_delivery === "delivered"
                ? moment(fetchedDate).isBefore(currentDate)
                : moment(fetchedDateCollect).isBefore(currentDate)
            }
          >
            <span className="button-spacing-left">Send Order To Rocks</span>
          </Button>
      )}
      
      {permissions !== "isManual" &&
        data &&
        (data.customer_order_status === 0 ||
          data.resend_status === "Re-send failed - Try again") && (
          <DeleteButton
            basePath={basePath}
            disabled={
              !!isResendBtnDisable || data.resend_status === "Re-sending"
            }
            record={data}
            resource={resource}
          />
        )}
    </TopToolbar>
  );
};

const SdoOrderMaterialsLink = () => {
  const record = useRecordContext();
  console.log("SdoOrderMaterialsLink record", record);
  if (
    record?.sap_materials_for_sdo &&
    record?.sap_materials_for_sdo.length > 0
  ) {
    return (
      <Button
        className="custom-button"
        component={Link}
        to={{
          pathname: "/sap_materials_for_sdos",
          search: `filter={"sap_sdo_for_order_id": ${record?.id}}`,
        }}
      >
        <span>Order Materials</span>
      </Button>
    );
  }
  return <span>No Order Materials</span>;
};

const SdoDisputeDetailsLink = () => {
  const record = useRecordContext();
  console.log("SdoDisputeDetailsLink record", record);
  if (record.sap_sdo_dispute && record.sap_sdo_dispute.length > 0) {
    return (
      <Button
        className="custom-button"
        component={Link}
        to={{
          pathname: "/sap_sdo_dispute/" + record.id + "/show",
          state: { record: { order_sdo_dispute: record } },
        }}
      >
        <span>Delivery Dispute</span>
      </Button>
    );
  }
  return <span>No Delivery Dispute</span>;
};

const DigitalOrderTitle = () => {
  const record = useRecordContext();
  return <span>{record ? `Order No. ${record.order_number} ` : ""}</span>;
};

const MyDatagridRow = ({ id, permissions }) => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");

  if (RecordId.includes(record.id)) {
    DeliveryNumber += 1;
  } else {
    RecordId.push(record.id);
  }

  return (
    <TableRow key={record.id}>
      {/* {permissions === "isManual" && ( */}
      <TableCell>
        <EditButton record={record} basePath={resource} />
      </TableCell>
      {/* )} */}
      <TableCell>{DeliveryNumber}</TableCell>
      {/* <TableCell>
                {record.logon_order_no}
            </TableCell> */}
      {sdoFieldSettings &&
        sdoFieldSettings.shipment_number &&
        sdoFieldSettings.shipment_number.enabled && (
          <TableCell>{record.shipment_number}</TableCell>
        )}
      {sdoFieldSettings &&
        sdoFieldSettings.load_number &&
        sdoFieldSettings.load_number.enabled && (
          <TableCell>{record.load_number}</TableCell>
        )}
      {permissions === "isSap" && (
        <TableCell>{record.logon_order_no}</TableCell>
      )}
      <TableCell>{record.order_status_description}</TableCell>
      <TableCell>
        {record.loading_date &&
          moment(record.loading_date).format("DD/MM/YYYY, h:MM:SS A")}
      </TableCell>
      <TableCell>{record.truck_plate_no}</TableCell>
      <TableCell>{record.lsd_order_no}</TableCell>
      {permissions === "isSap" && <TableCell>{record.on_hold}</TableCell>}
      {permissions === "isSap" && (
        <TableCell>{record.order_validation_code}</TableCell>
      )}
      {permissions === "isSap" && <TableCell>{record.pod_code}</TableCell>}
      <TableCell>
        {(record.receive_full_order === true && "YES") ||
          (record.receive_full_order === false && "NO")}
      </TableCell>
      <TableCell>
        {record.received_date &&
          moment(record.received_date).format("DD/MM/YYYY, h:MM:SS A")}
      </TableCell>
      <TableCell>
        {record.sap_sdo_dispute &&
          record.sap_sdo_dispute.length > 0 &&
          moment(record.sap_sdo_dispute[0].created_at).format(
            "DD/MM/YYYY, h:MM:SS A"
          )}
      </TableCell>
      <TableCell>
        <SdoOrderMaterialsLink />
      </TableCell>
      <TableCell>
        <SdoDisputeDetailsLink record={record} />
      </TableCell>
    </TableRow>
  );
};

const MyDatagridBody = (props) => {
  console.log("props........", props);
  return (
    <DatagridBody
      {...props}
      row={<MyDatagridRow permissions={props.permissions} />}
    />
  );
};

const MyDatagrid = (props) => {
  DeliveryNumber = 0;
  console.log("props../././.", props);
  return (
    <Datagrid
      {...props}
      body={<MyDatagridBody permissions={props.permissions} />}
    />
  );
};

const PayerField = () => {
  const record = useRecordContext();
  return (
    <div className="payer-section">
      <div className="payer-label">Payer</div>
      <div className="payer-value">
        {record.payerDetails && record.payerDetails.payer_name}(
        {record.payerDetails && record.payerDetails.payer_sap_code})
      </div>
    </div>
  );
};

const CustomerOrderStatusField = ({
  isChildResendBtnDisable,
  countryCodeArray,
}) => {
  const record = useRecordContext();
  console.log("_______", isChildResendBtnDisable, record);
  if (
    record.resend_status !== null &&
    !isChildResendBtnDisable &&
    record.resend_status === "Re-send failed - Try again"
  ) {
    return (
      <div className="payer-section">
        <div className="payer-label">Order Status</div>
        <div className="payer-value">
            {record.resend_status}
        </div>
      </div>
    );
  } else if (!!isChildResendBtnDisable) {
    return (
      <div className="payer-section">
        <div className="payer-label">Order Status</div>
        <div className="payer-value">Re-sending</div>
      </div>
    );
  } else {
    return (
      <div className="payer-section">
        <div className="payer-label">Order Status</div>
        <div className="payer-value">
            {record.customer_order_status_desc}
        </div>
      </div>
    );
  }
};

const DigitalOrdersShow = (props) => {
  const translate = useTranslate();
  const record = useRecordContext();
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];
  console.log("recorddddddddd", location);
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];

  const [isChildResendBtnDisable, setIsChildResendBtnDisable] = useState(false);
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const ClearFiltersOnMount = () => {
    const { setFilters } = useListContext();

    useEffect(() => {
        setFilters({}, []);
    }, [setFilters]);

    return null;
  };

  const receiveChildValue = (value) => {
    console.log("Parent received value from child: " + value);
    // this.setState({ isChildResendBtnDisable: JSON.parse(value) });
    setIsChildResendBtnDisable(JSON.parse(value));
  };

  const onCloseMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const onOkMessageModal = () => {
    // this.setState({ openMessageModal: false });
    setOpenMessageModal(false);
  };

  const showModalForEdit = () => {
    // this.setState({ openMessageModal: true });
    setOpenMessageModal(true);
  };

  const { permissions } = usePermissions();
  const resource = useResourceContext();
  // const record = useRecordContext();
  const sdoFieldSettings = getLocalStorageKey("sdo_field_settings");
  const showLineItemEdit = getLocalStorageKey("show_line_item_edit");
  console.log("sdoFieldSettings", sdoFieldSettings);

  const TruckPlateField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const EditBtnField = () => {
    const record = useRecordContext();
    const resource = useResourceContext();
    console.log("XXXXXXXXXXX", record, resource);
    return (
      <EditButton
        resource={resource}
        to={{
          pathname: `/sap_sdo_for_orders/${record.id}`,
          state: {
            order: record,
          },
        }}
        label="Edit"
      />
    );
  };

  const LsdOrderNoField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const ReceiveFullOrderField = ({ source }) => {
    const record = useRecordContext();
    return (
      <span>
        {record[source] === "-" ? "-" : record[source] ? record[source] : "-"}
      </span>
    );
  };

  const LoadingDateField = ({ source }) => {
    const record = useRecordContext();
    if (record[source] === null) {
      return <span>{"-"}</span>;
    }

    return <DateField record={record} source={source} />;
  };

  const ReceivedDateField = ({ source }) => {
    const record = useRecordContext();
    if (record[source] === null) {
      return <span>{"-"}</span>;
    }

    return <DateField record={record} source={source} />;
  };

  const CustomeOnHold = ({ source }) => {
    const record = useRecordContext();
    console.log("CustomeOnHold record", record);
    return (
      <span
        className={record.on_hold ? "e1-error" : ""}
        // style={{
        //   fontSize: "0.875rem",
        //   fontFamily: "NeueEinstellung,Arial,sans-serif",
        //   fontWeight: "400",
        //   lineHeight: "1.43",
        // }}
      >
        {record.on_hold ? "Yes" : "No"}
      </span>
    );
  };
  const recordData = useShowController();
  console.log("recordData", recordData?.record);
  const Mod = recordData?.record?.mode_of_delivery;
  const isRocksOrder = recordData?.record?.is_rocks_order;
  console.log("ModModModModMod", recordData?.record);
  const orderPendingNote = recordData?.record?.sap_order_failed_message;

  const ModeTransport = ({ source }) => {
    const record = useRecordContext();
    const str = record.truck_or_trips;
    return (
      <span>{str ? str.charAt(0).toUpperCase() + str.slice(1) : "-"}</span>
    );
  };

  const QtyField = ({ source }) => {
    const record = useRecordContext();
    if (countryCode === "FR") {
      return (
        <span>
          {record.truck_or_trips === "rotation" ? "-" : record.quantity}
        </span>
      );
    }
    return <span>{record.quantity}</span>;
  };

  const newTab = (url) => {
    window.open(url, "_blank");
  };

  const AttachmentFiles = () => {
    const record = useRecordContext();    
    
    if (!record) return null;
  
    return (
      <div className="complaint-files-onshow">
                  {record.sap_digital_order_files &&
                  record.sap_digital_order_files.length === 0 ? (
                    <div>
                      <div className="complaint-files-label">
                        {translate("resources.complaints.fields.file_uploaded")}
                      </div>
                      <p className="no-files-uploaded">
                        {translate(
                          "resources.complaints.fields.no_file_uploaded"
                        )}
                      </p>
                    </div>
                  ) : (
                    <div className="complaint-files">
                      <div className="complaint-files-label">
                        {translate("resources.complaints.fields.file_uploaded")}
                      </div>
                      <div className="upload-file-section">
                        <div className="files-uploaded">
                          <div className="files-uploaded-section">
                            <div className="uploaded-files-container">
                              {record.sap_digital_order_files &&
                                record.sap_digital_order_files
                                  .filter((file) => file.order_upload_file_url != null)
                                  .map((file) => {
                                    // record.complaint_files && record.complaint_files.map(file => {

                                    let fileExtension = file?.order_upload_file_url.split('.').pop().split('?')[0].toLowerCase();
                                    const filePath = file?.order_upload_file_url?.split('amazonaws.com/')[1]?.split('?')[0];
                                    const filename = filePath?.split('/')?.pop() ?? '';


                                    return (
                                      <div
                                        className="complaint-file-content"
                                        onClick={() => {
                                          newTab(file.order_upload_file_url);
                                        }}
                                      >
                                          <div>
                                            {['jpg', 'jpeg', 'png'].includes(fileExtension) ? (
                                              <img
                                                src={file.order_upload_file_url}
                                                title={
                                                  filename
                                                }
                                              />
                                            ) : (
                                              <img
                                                src={noImage}
                                                title={
                                                  filename
                                                }
                                              />
                                            )}
                                            <p
                                              title={
                                                filename
                                              }
                                            >
                                              {
                                                filename
                                              }
                                            </p>
                                          </div>
                                      </div>
                                    );
                                  })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
    )
  };

  const TruckOrTripsSummary = ({ source }) => {
  const record = useRecordContext();

  if (!record || !Array.isArray(record[source])) return null;

  const items = record[source];

  const rotationCount = items.filter((item) => item.truck_or_trips === 'rotation').length;
  const tonnageCount = items.filter((item) => item.truck_or_trips === 'tonnage').length;

  return (
    <span>
      {tonnageCount > 0 && `${tonnageCount} Tonnage `}
      {rotationCount > 0 && `${rotationCount} Rotation`}
    </span>
  );
};

  return (
    <div>
      <Show
        title={<DigitalOrderTitle />}
        actions={
          <ShowActions
            fromChildToParentCallback={receiveChildValue}
            permissions={permissions}
          />
        }
        {...props}
      >
        <TabbedShowLayout className="tab-scroll">
          <Tab
            label={translate(
              "resources.sap_digital_app_orders.fields.orderDetails"
            )}
            contentClassName="scrollTab"
          >
            <TextField source="order_number" />
            {/* <TextField label="Order Status" source="customer_order_status_desc" /> */}
            <CustomerOrderStatusField
              isChildResendBtnDisable={isChildResendBtnDisable}
              countryCodeArray={localStorageLocale}
            />

            {
              localStorageLocale == "en-GB" &&
              <TextField 
              label= {isRocksOrder ? "Sent to Rocks By" : "Sent to E1 by"}
              source="admin_user_name" />
            }

            <ReferenceField
              // label="Sold To Name"
              source="business_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>
            <TextField
              // label="Ship To Name"
              source="business_site.name"
            />
            {/* <ReferenceField
                          label="Ship To Name"
                          source="sap_business_site_id"
                          reference="sap_business_sites"
                          link="show"
                          allowEmpty
                        >
                          <TextField source="name" />
                        </ReferenceField> */}
            {permissions === "isSap" && <PayerField />}
            {/* <ReferenceField label="Contract Number" source="sap_contract_id" reference="sap_contracts" linkType="show" allowEmpty>
                            <TextField  source="contarctDetails.contract_number" />
                        </ReferenceField> */}

            {Mod === "delivered" && (
              <TextField
                source="delivery_address"
                // label="Delivery Address"
              />
            )}

            {Mod === "delivered" && (
              <TextField source="contact_at_site" label="Contact at Site" />
            )}

            {Mod === 'rotation' && (
              <Labeled label="Rotations / Tonnage">
                <TruckOrTripsSummary source="digital_order_line_items" />
              </Labeled>
            )}
            
            <ReferenceField
              // label="User name"
              source="user_id"
              reference="users"
              link="show"
              allowEmpty
            >
              <FunctionField
                render={(record) => `${record.first_name} ${record.last_name}`}
              />
            </ReferenceField>
            {/* <ExpectedDateField
                label="Expected Date"
                source="delivery_date_from"
                addLabel
              /> */}
            <DateField
              // label="Requested Delivery Date"
              source="delivery_date_from"
            />

            <TextField
              // label="Local PO Note"
              source="local_po_note"
            />
            {/* {Mod === "self_collect" && (
              <TextField
                source="sap_plant"
                // label="Plant Name"
              />
            )} */}
            {Mod === "self_collect" && (
              <TextField
                source="truck_number"
                // label="Truck Number"
              />
            )}
            {Mod === "self_collect" && (
              <TextField
                source="driver_details"
                // label="Driver Details"
              />
            )}
            <TextField source="is_app_order" sortable={false} />

            <TextField
              label="Contract Number"
              source="contarctDetails.contract_number"
            />
            {orderPendingNote && (
              <TextField
                // label="Order Pending Note"
                source="sap_order_failed_message"
              />
            )}
            {/* <TextField source="customer_ref_number" label="Special Instruction"/> */}
            <TextField source="special_instructions" />
            {Mod === "delivered" && <TextField source="mode_of_transport" />}
            {Mod === "delivered" && <TextField source="vehicle_type" />}
            {Mod === "delivered" && (
              <TextField
                source="delivery_time_pref"
                label="Delivery Time Preference"
              />
            )}

            {
              countryCode == "GB" &&
              <CustomeOnHold source="on_hold" label="Order On Hold" addLabel />
            }

            {/* {Mod === "delivered" && countryCode == "GB" && (
              <div className="payer-section">
                <div className="payer-label">
                  {translate(
                    "resources.sap_digital_app_orders.fields.site_opening"
                  )}
                </div>
                <div className="payer-value">
                  {moment(recordData?.record?.delivery_date_from).format(
                    "HH:mm"
                  )}
                </div>
              </div>
            )} */}

            {/* {Mod === "delivered" && countryCode == "GB" && (
              <div className="payer-section">
                <div className="payer-label">
                  {translate(
                    "resources.sap_digital_app_orders.fields.site_closing"
                  )}
                </div>
                <div className="payer-value">
                  {moment(recordData?.record?.delivery_to_date).format("HH:mm")}
                </div>
              </div>
            )} */}

            {Mod === "delivered" && countryCode == "GB" && (
              <div className="payer-section">
                <div className="payer-label">
                  {translate(
                    "resources.sap_digital_app_orders.fields.delivery_window"
                  )}
                </div>
                <div className="payer-value">
                {moment(recordData?.record?.delivery_date_from).format("HH:mm")} - {moment(recordData?.record?.delivery_to_date).format("HH:mm")}
                </div>
              </div>
            )}
            {/* <TextField source="payment_method" /> */}
            {/* <PaymentAmountField source="payment_amount" addLabel /> */}
            {/* <TextField source="payment_status" /> */}
            {/* <TextField source="business_site.ship_to_sap_number" label="Ship-To number" /> */}
            {/* <TextField source="order_total_price" label="Total Amount" />
                        <TextField source="order_total_tons" label="Total Tons" /> */}
            {/* {permissions === "isSap" && <TextField source="sales_org" />}
              {permissions === "isSap" && (
                <TextField source="distrib_channel" />
              )}
              {permissions === "isSap" && <TextField source="division" />}
              {permissions === "isSap" && <TextField source="comp_code_cd" />}
              {permissions === "isSap" && (
                <DateField label="Date 1st seen in LR" source="created_at" />
              )}
              {permissions === "isSap" &&
                props.resource !== "sap_digital_app_orders" &&
                getLocalStorageKey("show_all_orders") && (
                  <TextField label="Is App Order" source="is_app_order" />
                )}
              {permissions === "isSap" &&
                props.resource === "sap_digital_app_orders" && (
                  <BooleanField label="On Hold" source="on_hold" />
                )} */}
              <AttachmentFiles/>
          </Tab>
          <Tab
            label={translate(
              "resources.sap_digital_app_orders.fields.line_items"
            )}
          >
            <ReferenceManyField
              label=""
              sort={{ field: "created_at", order: "DESC" }}
              reference="sap_digital_order_line_items"
              target="sap_digital_order_id"
              className="tab-pagination"
              source="id"
            >
              <List
                className="tab-list"
                // title="Line Items"
                // {...props}
                filterDefaultValues={{ sap_digital_order_id: businessIdVal }}
                sort={{ field: "created_at", order: "DESC" }}
                exporter={false}
                hasCreate={false}
                actions={false}
                disableSyncWithLocation
              >
                {/* <ClearFiltersOnMount /> */}
                <Datagrid bulkActionButtons={false}>
                  {(showLineItemEdit &&
                    Number(orderStatus) < 3 &&
                    isSdoCreated === 0) ||
                  props.permissions === "isManual" ? (
                    <EditButton />
                  ) : showLineItemEdit ? (
                    <button
                      className="edit-modal-btn"
                      onClick={showModalForEdit}
                    >
                      Edit
                    </button>
                  ) : (
                    ""
                  )}
                  <TextField source="material_no" />
                  <TextField
                    source="product_master.name"
                    // label="Product Name"
                  />
                  {/* {
                                    permissions === 'isSageAPI' ?
                                    <MaterialQtyUom label="Quantity" /> :
                                    <NumberField source="quantity" label="Quantity (Tons)" />
                                    
                                }
                                {
                                    permissions !== 'isSageAPI' &&
                                    <NumberField source="quantity_bags" label="Quantity (Bags)" />
                                }
                                {
                                    permissions === 'isSageAPI' ?
                                    <MaterialQtyUom label="Dispatched Quantity" /> :
                                    <NumberField source="dispatched_quantity" label="Dispatched Quantity (Tons)" />
                                }
                                {
                                    permissions !== 'isSageAPI' &&
                                    <NumberField source="dispatched_quantity_bags" label="Dispatched Quantity (Bags)" />
                                } */}
                  {countryCode == "FR" && (
                    <ModeTransport source="truck_or_trips" label="Mode" />
                  )}
                  <QtyField source="quantity" label="Quantity" />
                  {/* <NumberField source="quantity" /> */}
                  {countryCode != "FR" && (
                    <TextField
                      source="product_master.input_uom_name"
                      label="UOM"
                    />
                  )}
                  <TextField source="plant_name" label="Supply Unit" />
                  {countryCode == "FR" && <TextField source="ship_to_code" label="Site Number" />}
                  {countryCode == "FR" && <TextField source="ship_to_name" label="Ship To" />}
                  {countryCode == "FR" && <TextField source="truck_type" label="Truck Type" />}
                  {countryCode == "FR" && <TextField source="duration" label="Period"/>}
                  {countryCode == "FR" && <TextField source="start_time" />}
                  {countryCode == "FR" && <TextField source="end_time" />}
                  {countryCode == "FR" && <TextField source="comment" />}
                  {countryCode == "FR" || countryCode == "GB" && <TextField source="truck_type" />}

                  {countryCode == "FR" && (
                    <TextField
                      source="product_master.name"
                      label="Material Name"
                    />
                  )}
                  {countryCode == "FR" && <TextField source="material_no" />}
                  {countryCode == "FR" && <TextField source="plant_name" />}
                  {countryCode == "FR" && <TextField source="plant_code" />}
                  {/* <ConvQtyField
                      source="quantity"
                      label="Quantity Conversion"
                    /> */}
                  {/* <ConvQtyUomField
                      source="conversion_uom_name"
                      label="Quantity Conversion UOM"
                    />
                    <NumberField
                      source="dispatched_quantity"
                      label="Dispatched Quantity"
                    /> */}
                  {/* <TextField
                      source="product_master.input_uom_name"
                      label="Dispatched Quantity UOM"
                    />
                    <ConvQtyField
                      source="dispatched_quantity"
                      label="Dispatched Quantity Conversion"
                    /> */}
                  {/* <ConvQtyUomField
                      source="product_master.input_uom_name"
                      label="Dispatched Quantity Conversion UOM"
                    />
                    <AmountField source="unit_price" label="Unit Price" />
                    <LineItemTotalField label="Total" /> */}
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
          <Tab
            label={translate(
              "resources.sap_digital_app_orders.fields.single_delivery"
            )}
          >
            <CreateSDOButton />
            <ReferenceManyField
              label=""
              sort={{ field: "creation_date", order: "ASC" }}
              reference="sap_sdo_for_orders"
              target="sap_digital_order_id"
              className="tab-pagination"
            >
              <List
                className="tab-list"
                // {...props}
                filterDefaultValues={{ sap_digital_order_id: businessIdVal }}
                sort={{ field: "created_at", order: "DESC" }}
                // bulkActionButtons={false}
                exporter={false}
                hasCreate={false}
                actions={false}
              >
                {/* <ClearFiltersOnMount /> */}
                <Datagrid
                  // rowClick="show"
                  permissions={permissions}
                  bulkActionButtons={false}
                >
                  <EditBtnField />
                  {/* <EditButton basePath={resource} label="Edit" /> */}

                  {permissions === "isManual" && <TextField source="edit" />}
                  <TextField
                    label="Delivery Number"
                    source="delivery_plant_no"
                  />
                  {/* <TextField label="Sales Order Number" source="logon_order_no" sortable={false} /> */}
                  {sdoFieldSettings &&
                    sdoFieldSettings.shipment_number &&
                    sdoFieldSettings.shipment_number.enabled && (
                      <TextField
                        // label="Shipment Number"
                        source="shipment_number"
                        sortable={false}
                      />
                    )}
                  {sdoFieldSettings &&
                    sdoFieldSettings.load_number &&
                    sdoFieldSettings.load_number.enabled && (
                      <TextField
                        // label="Loading Number"
                        source="load_number"
                        sortable={false}
                      />
                    )}
                  {/* {permissions === "isSap" && (
                      <TextField
                        label="Load Number"
                        source="logon_order_no"
                        sortable={false}
                      />
                    )} */}
                  <TextField
                    // label="Status"
                    source="order_status_description"
                    sortable={false}
                  />
                  <LoadingDateField
                    showTime={true}
                    // label="Loading date"
                    source="loading_date"
                    sortable={false}
                  />
                  <TruckPlateField source="truck_plate_no" sortable={false} />
                  <LsdOrderNoField
                    // label="Delivery Note"
                    source="lsd_order_no"
                    sortable={false}
                  />
                  {/* {permissions === "isSap" && (
                      <TextField
                        label="On Hold"
                        source="on_hold"
                        sortable={false}
                      />
                    )}
                    {permissions === "isSap" && (
                      <TextField
                        source="order_validation_code"
                        sortable={false}
                      />
                    )}
                    {permissions === "isSap" && (
                      <TextField
                        label="POD Code"
                        source="pod_code"
                        sortable={false}
                      />
                    )} */}
                  <ReceiveFullOrderField
                    // label="Received"
                    source="receive_full_order"
                    sortable={false}
                  />
                  <ReceivedDateField
                    source="received_date"
                    sortable={false}
                    showTime={true}
                  />
                  <DateField
                    // label="Disputed Time"
                    source="created_at"
                    sortable={false}
                    showTime={true}
                  />
                  <SdoOrderMaterialsLink />
                  <SdoDisputeDetailsLink />
                </Datagrid>
              </List>
            </ReferenceManyField>
          </Tab>
        </TabbedShowLayout>
      </Show>
      {openMessageModal && (
        <CustomModal
          open={openMessageModal}
          onCloseModal={onCloseMessageModal}
          showCancel={false}
          text="Yo can not edit line items untill you delete all single deliveries."
          onOkModal={onOkMessageModal}
          data={""}
        />
      )}
    </div>
  );
};

export default DigitalOrdersShow;
